import React from 'react';

import { Outlet } from 'react-router-dom';

const InventoryStockContent = () => {
  return <Outlet />;
};

export default InventoryStockContent;
